var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useId } from "react";
import { Box, Checkbox, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { stringToHtml, translateFromPresentation } from "@sequentech/ui-core";
var StyledCheckboxWrapper = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    cursor: pointer;\n    align-items: flex-start;\n    padding: 10px 0;\n"], ["\n    display: flex;\n    flex-direction: row;\n    cursor: pointer;\n    align-items: flex-start;\n    padding: 10px 0;\n"])));
var StyledCheckbox = styled(Checkbox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-top: 4px;\n    margin-right: 9px;\n    padding: 0;\n"], ["\n    margin-top: 4px;\n    margin-right: 9px;\n    padding: 0;\n"])));
/**
 * The eligibility declaration a voter must accept before starting to vote, shown
 * when `security_confirmation_policy` is MANDATORY. The declaration is legally
 * significant, so the checkbox has to carry it as its accessible name rather than
 * sitting next to it as unrelated text.
 */
export var SecurityConfirmation = function (_a) {
    var _b, _c;
    var election = _a.election, checked = _a.checked, onChange = _a.onChange;
    var i18n = useTranslation().i18n;
    // The declaration is admin-authored HTML, so it labels the checkbox by
    // reference rather than by being nested inside a <label>, which may not
    // contain arbitrary markup.
    var declarationId = useId();
    var declaration = (_c = (_b = translateFromPresentation(election, "security_confirmation_html", i18n.language)) !== null && _b !== void 0 ? _b : translateFromPresentation(election, "security_confirmation_html", "en")) !== null && _c !== void 0 ? _c : "-";
    return (_jsxs(StyledCheckboxWrapper, { className: "security-confirmation", onClick: function () { return onChange(!checked); }, children: [_jsx(StyledCheckbox, { className: "security-confirmation-checkbox", checked: checked, onChange: function (event) { return onChange(event.target.checked); }, 
                // The wrapper keeps the whole row clickable for mouse users;
                // without this the wrapper would toggle a second time and cancel
                // the checkbox's own change.
                onClick: function (event) { return event.stopPropagation(); }, slotProps: { input: { "aria-labelledby": declarationId } } }), _jsx(Typography, { className: "security-confirmation-label", variant: "body2", 
                // Never a plain Typography: the default renders a <p>, and the
                // admin HTML routinely contains block elements.
                component: "div", marginTop: "4px", id: declarationId, children: stringToHtml(declaration) })] }));
};
export default SecurityConfirmation;
var templateObject_1, templateObject_2;
